import { createContext, useState } from "react";

export const AddSizeChartContext = createContext();

export const AddSizeChartContextProvider = ({ children }) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [sizeChartName, setSizeChartName] = useState('');
    const [extraColumnKeys, setExtraColumnKeys] = useState([]);

    const [sizeChartFormData, setSizeChartFormData] = useState([]);

    const contextValue = {
        selectedCategory,
        setSelectedCategory,
        sizeChartName,
        setSizeChartName,
        sizeChartFormData,
        setSizeChartFormData,
        extraColumnKeys,
        setExtraColumnKeys
    };

    return (
        <AddSizeChartContext.Provider value={ contextValue }>
            { children }
        </AddSizeChartContext.Provider>
    );
}
